
import EN from '../secrets-web/src/locale/en.json';
import VI from '../secrets-web/src/locale/vi.json';
import ZH from '../secrets-web/src/locale/zh.json';
import RU from '../secrets-web/src/locale/ru.json';
import FR from '../secrets-web/src/locale/fr.json';

import en from './en.json';
import vi from './vi.json';
import zh from './zh.json';
import ru from './ru.json';
import fr from './fr.json';

import { mergeJsonContent } from '../utils/common';

export default {
  en: mergeJsonContent(EN, en),
  vi: mergeJsonContent(VI, vi),
  zh: mergeJsonContent(ZH, zh),
  ru: mergeJsonContent(RU, ru),
  fr: mergeJsonContent(FR, fr),
}